function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { ApiConstants, InjectorHelper, SessionSelectors, ThunkHelper } from 'invision-core';
import { GiftCardSearchRecordCountSelector, GiftCardSearchArraySelector } from '../selectors/search.giftcard.selectors';
import { hideSearchPanel } from './search.actions';
import { GIFT_CARD_DETAILS } from '../../components/giftCard/gift.card.config';
export var GIFT_CARD_SEARCH = {
  BEGIN: 'GIFT_CARD_SEARCH_BEGIN',
  SUCCESS: 'GIFT_CARD_SEARCH_SUCCESS',
  FAILURE: 'GIFT_CARD_SEARCH_FAILURE'
};
var GIFT_CARD_SEARCH_EVENTS = [GIFT_CARD_SEARCH.BEGIN, GIFT_CARD_SEARCH.SUCCESS, GIFT_CARD_SEARCH.FAILURE];
export var SET_GIFT_CARD_SEARCH_MODEL = 'SET_GIFT_CARD_SEARCH_MODEL';
export var setGiftCardSearchModel = function setGiftCardSearchModel(payload) {
  return {
    type: SET_GIFT_CARD_SEARCH_MODEL,
    payload: payload
  };
};
export var RESET_SEARCH_GIFT_CARD_MODEL_RECOVERABLE = 'RESET_SEARCH_GIFT_CARD_MODEL_RECOVERABLE';
export var resetGiftCardSearchRecoverable = function resetGiftCardSearchRecoverable() {
  return {
    type: RESET_SEARCH_GIFT_CARD_MODEL_RECOVERABLE
  };
};
var giftCardSearchPromise = function giftCardSearchPromise(dispatch, giftCardSearchModel, pageNumber, pageSize) {
  var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : GIFT_CARD_SEARCH_EVENTS;
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  return ThunkHelper(dispatch, events, {
    method: 'post',
    url: 'SubscriberManagement/SearchGiftCardRedemptions',
    headers: _defineProperty({}, ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, SessionSelectors.LanguageHeaderSelector(state)),
    data: {
      AccountNumber: giftCardSearchModel.accountNumber,
      PageSize: pageSize,
      PageNumber: pageNumber,
      Pin: giftCardSearchModel.pin,
      SenderEmail: giftCardSearchModel.senderEmail
    }
  });
};
export var SET_GIFT_CARD_SEARCH_PAGE = 'SET_GIFT_CARD_SEARCH_PAGE';
export var setGiftCardSearchPageInStore = function setGiftCardSearchPageInStore(pageNumber) {
  return {
    type: SET_GIFT_CARD_SEARCH_PAGE,
    payload: pageNumber
  };
};
export var getGiftCardSearch = function getGiftCardSearch(giftCardSearchModel, pageNumber, pageSize) {
  return function (dispatch) {
    return giftCardSearchPromise(dispatch, giftCardSearchModel, pageNumber, pageSize).then(function () {
      dispatch(setGiftCardSearchPageInStore(pageNumber));
      var $ngRedux = InjectorHelper.getNgReduxService();
      if (GiftCardSearchRecordCountSelector($ngRedux.getState()) === 1) {
        var giftCard = GiftCardSearchArraySelector($ngRedux.getState())[0];
        dispatch(routeToGiftCard(giftCard));
      }
    });
  };
};
export var routeToGiftCard = function routeToGiftCard(giftCard) {
  // Defaults state and params
  var state = GIFT_CARD_DETAILS;
  var params = {
    giftCardId: giftCard.Id
  };
  return function (dispatch) {
    dispatch(stateGo(state, params, {
      reload: true
    }));
    dispatch(hideSearchPanel());
  };
};